import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { max: Number };
  static targets = ['checkbox', 'message'];

  connect() {
    this.updateState();
  }

  toggle(event) {
    const checkbox = event.target;
    
    // If trying to check, count will be +1 after this check
    if (checkbox.checked) {
      const checkedCount = this.checkboxTargets.filter((cb) => cb.checked).length;
      
      // If already at max, prevent checking this one
      if (checkedCount > this.maxValue) {
        checkbox.checked = false;
        this.showMessage();
        event.preventDefault();
        return false;
      }
    }

    this.updateState();
  }

  get checkedCount() {
    return this.checkboxTargets.filter((cb) => cb.checked).length;
  }

  updateState() {
    const checkedCount = this.checkedCount;
    const atLimit = checkedCount >= this.maxValue;

    // Disable unchecked checkboxes when at limit
    this.checkboxTargets.forEach((checkbox) => {
      if (!checkbox.checked && atLimit) {
        checkbox.disabled = true;
      } else {
        checkbox.disabled = false;
      }
    });

    // Update message visibility
    if (this.hasMessageTarget) {
      if (atLimit && checkedCount > 0) {
        this.messageTarget.classList.remove('d-none');
      } else {
        this.messageTarget.classList.add('d-none');
      }
    }
  }

  showMessage() {
    if (this.hasMessageTarget) {
      this.messageTarget.classList.remove('d-none');
      // Hide message after a few seconds
      setTimeout(() => {
        this.messageTarget.classList.add('d-none');
      }, 3000);
    }
  }
}

